export default {
    isElectron: function(){
        return false;
    }
}
